import type { FC } from "react";
import React, { createContext, useContext, useMemo } from "react";
import { buildSchema } from "graphql";
import type { GraphQLSchema } from "graphql";

interface FrontendApiConfigContext {
  graphQLEndpoint: string;
  schema: GraphQLSchema;
  namespace?: string;
}

const DEFAULT_NAMESPACE = "default";

const FrontendApiConfigContext = createContext<FrontendApiConfigContext | null>(
  null,
);

export const useFrontendApiConfig = (): FrontendApiConfigContext | null =>
  useContext(FrontendApiConfigContext);

export interface FrontendApiConfigProviderProps {
  graphQLEndpoint: string;
  schema: string;
  namespace?: string;
}

export const FrontendApiConfigProvider: FC<FrontendApiConfigProviderProps> = ({
  graphQLEndpoint,
  schema,
  namespace = DEFAULT_NAMESPACE,
  children,
}) => {
  const builtSchema = useMemo(() => buildSchema(schema), [schema]);
  return (
    <FrontendApiConfigContext.Provider
      value={{ graphQLEndpoint, schema: builtSchema, namespace }}
    >
      {children}
    </FrontendApiConfigContext.Provider>
  );
};
